import styled from "styled-components";

const Input = styled.input`
  width: 100%;
  line-height: 2;
  padding: 8px 10px;
  background: #fdfdfd;
  border: solid 1px #cccc;
  border-radius: 5px;
  margin-bottom: 20px;
  font-size: 16px;
`;
export default Input;
